import {HttpMethod as Http, OxApi, Token, Url, UrlType} from '@ox/typings';

export function makeAPI<T extends UrlType>(
  URL: Url<T>,
  METHODS: Http[],
  TOKEN: Token,
  LOCALIZED = true,
  VERSIONAL = false
): OxApi<T> {
  return {URL, METHODS, TOKEN, VERSIONAL, LOCALIZED};
}
